import { Injectable } from '@angular/core';
import { Globals } from '../../globals';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})

export class SpecificationService {
    constructor(private global: Globals, private _httpClient: HttpClient) { }

 

    GetSpecificationList() {
        let headers:HttpHeaders=new HttpHeaders();
        headers=headers.append('Authorization', "Bearer " + this.global.loggedUser.token);
        return this._httpClient.get(this.global.G_apiUrl +'/specification/CounterByUser/'+
        this.global.loggedUser.user.user_reg_id,{headers:headers});
    }

    GetIndividualSpecList(specId:any)
    {
        let headers:HttpHeaders=new HttpHeaders();
        headers=headers.append('Authorization', "Bearer " + this.global.loggedUser.token);
        return this._httpClient.get(this.global.G_apiUrl +'/approvedEmail/approvedBySpecification/'+
        this.global.loggedUser.user.user_reg_id+'/'+specId,{headers:headers});
    }
}